console.log("process.env: ", process.env);
console.log("location: ", window.location);
export const config = process.env.NODE_ENV === "production" ?

    window.location.host === "dajcz.ipcall.com.ar" ? {
        URL_API: process.env.REACT_APP_DAJCZ_URL_API,
        URL_STATIC: process.env.REACT_APP_DAJCZ_URL_API,
        URL_API_IPCALL: process.env.REACT_APP_DAJCZ_URL_API_IPCALL,
        URL_ESPEJO_STATIC: process.env.REACT_APP_URL_ESPEJO_STATIC,
        URL_BANCOS: process.env.REACT_APP_URL_BANCOS,

        TELEFONO: process.env.REACT_APP_DAJCZ_TELEFONO,
        WHATSAPP: process.env.REACT_APP_DAJCZ_WHATSAPP,
        WHATSAPP_TEXTO: process.env.REACT_APP_DAJCZ_WHATSAPP_TEXTO,
        LOGO: process.env.REACT_APP_DAJCZ_LOGO,
        IMG_LOGIN: process.env.REACT_APP_DAJCZ_IMG_LOGIN,

    } : window.location.host === "autogestion.tonelli.ipcallgo.com" ? {
        URL_API: process.env.REACT_APP_TONNELLI_URL_API,
        URL_STATIC: process.env.REACT_APP_TONNELLI_URL_API,
        URL_API_IPCALL: process.env.REACT_APP_TONNELLI_URL_API_IPCALL,
        URL_ESPEJO_STATIC: process.env.REACT_APP_URL_ESPEJO_STATIC,
        URL_BANCOS: process.env.REACT_APP_URL_BANCOS,

        TELEFONO: process.env.REACT_APP_TONNELLI_TELEFONO,
        WHATSAPP: process.env.REACT_APP_TONNELLI_WHATSAPP,
        WHATSAPP_TEXTO: process.env.REACT_APP_TONNELLI_WHATSAPP_TEXTO,
        LOGO: process.env.REACT_APP_TONNELLI_LOGO,
        IMG_LOGIN: process.env.REACT_APP_TONNELLI_IMG_LOGIN,

    } : window.location.host === "tonelli.ipcallgo.com" ? {
        URL_API: process.env.REACT_APP_TONNELLI_URL_API,
        URL_STATIC: process.env.REACT_APP_TONNELLI_URL_API,
        URL_API_IPCALL: process.env.REACT_APP_TONNELLI_URL_API_IPCALL,
        URL_ESPEJO_STATIC: process.env.REACT_APP_URL_ESPEJO_STATIC,
        URL_BANCOS: process.env.REACT_APP_URL_BANCOS,

        TELEFONO: process.env.REACT_APP_TONNELLI_TELEFONO,
        WHATSAPP: process.env.REACT_APP_TONNELLI_WHATSAPP,
        WHATSAPP_TEXTO: process.env.REACT_APP_TONNELLI_WHATSAPP_TEXTO,
        LOGO: process.env.REACT_APP_TONNELLI_LOGO,
        IMG_LOGIN: process.env.REACT_APP_TONNELLI_IMG_LOGIN,

    } : window.location.host === "mjminversiones.ipcallgo.com" ? {
        URL_API: process.env.REACT_APP_TRESPINOS_URL_API,
        URL_STATIC: process.env.REACT_APP_TRESPINOS_URL_API,
        URL_API_IPCALL: process.env.REACT_APP_TRESPINOS_URL_API_IPCALL,
        URL_ESPEJO_STATIC: process.env.REACT_APP_URL_ESPEJO_STATIC,
        URL_BANCOS: process.env.REACT_APP_URL_BANCOS,

        TELEFONO: process.env.REACT_APP_TRESPINOS_TELEFONO,
        WHATSAPP: process.env.REACT_APP_TRESPINOS_WHATSAPP,
        WHATSAPP_TEXTO: process.env.REACT_APP_TRESPINOS_WHATSAPP_TEXTO,
        LOGO: process.env.REACT_APP_TRESPINOS_LOGO,
        IMG_LOGIN: process.env.REACT_APP_TRESPINOS_IMG_LOGIN,

    } : window.location.host === "trespinos.ipcallgo.com" ? {
        URL_API: process.env.REACT_APP_TRESPINOS_URL_API,
        URL_STATIC: process.env.REACT_APP_TRESPINOS_URL_API,
        URL_API_IPCALL: process.env.REACT_APP_TRESPINOS_URL_API_IPCALL,
        URL_ESPEJO_STATIC: process.env.REACT_APP_URL_ESPEJO_STATIC,
        URL_BANCOS: process.env.REACT_APP_URL_BANCOS,

        TELEFONO: process.env.REACT_APP_TRESPINOS_TELEFONO,
        WHATSAPP: process.env.REACT_APP_TRESPINOS_WHATSAPP,
        WHATSAPP_TEXTO: process.env.REACT_APP_TRESPINOS_WHATSAPP_TEXTO,
        LOGO: process.env.REACT_APP_TRESPINOS_LOGO,
        IMG_LOGIN: process.env.REACT_APP_TRESPINOS_IMG_LOGIN,

    } : {
        URL_API: 'http://localhost:4001/api',
        URL_STATIC: 'http://trespinos.ipcall.com.ar/static',
        URL_API_IPCALL: 'http://localhost:4000/api',
        URL_IPCALL_STATIC: 'http://192.168.100.26:3010/static',
        URL_BANCOS: 'https://www.grupoprego.com',

        TELEFONO: process.env.REACT_APP_DAJCZ_TELEFONO,
        WHATSAPP: process.env.REACT_APP_DAJCZ_WHATSAPP,
        WHATSAPP_TEXTO: process.env.REACT_APP_DAJCZ_WHATSAPP_TEXTO,
        LOGO: process.env.REACT_APP_DAJCZ_LOGO,
        IMG_LOGIN: process.env.REACT_APP_DAJCZ_IMG_LOGIN,
    } 
: {
    URL_API: "http://localhost:4001/api",
        URL_STATIC: process.env.REACT_APP_DAJCZ_URL_API,
        URL_API_IPCALL: process.env.REACT_APP_DAJCZ_URL_API_IPCALL,
        URL_ESPEJO_STATIC: process.env.REACT_APP_URL_ESPEJO_STATIC,
        URL_BANCOS: process.env.REACT_APP_URL_BANCOS,

        TELEFONO: process.env.REACT_APP_DAJCZ_TELEFONO,
        WHATSAPP: process.env.REACT_APP_DAJCZ_WHATSAPP,
        WHATSAPP_TEXTO: process.env.REACT_APP_DAJCZ_WHATSAPP_TEXTO,
        LOGO: process.env.REACT_APP_DAJCZ_LOGO,
        IMG_LOGIN: process.env.REACT_APP_DAJCZ_IMG_LOGIN,
}
